import { useEffect } from 'react';

function Trustspot(props) {

	useEffect(() => {
		window.trustspot_init();
	}, []);

	if(typeof(props.product) === "undefined") {
		return (
			<div></div>
		);
	}
	
	if(props.type === 'stars') {
		return (
			<div className={"trustspot-inline-product"} data-product-sku={props.product._netsuite_externalId}></div>
		);
	}

	return (
		<div className={"trustspot trustspot-main-widget"} data-product-sku={props.product._netsuite_externalId} data-name={props.product.product_name} id="trustspot-main-widget"></div>
	);
}

export default Trustspot;
